/* global G */
import ui from 'lib/hook/ui/update'
import submit from 'lib/hook/model/submit'
import validate from 'lib/hook/model/validate'
import reset from 'app/_shared/hook/component/reset'
import onlineCheck from 'app/_shared/hook/onlineCheck'
import check from 'app/_shared/hook/check'
import updateCache from 'app/_shared/hook/model/updateCache'
import back from 'app/_shared/hook/redirect/back'
import withToast from 'app/adminNotice/hook/withToast'

const _formHooks = {
  before: [
    onlineCheck(),
    reset,
  ],
  after: [
    ui,
  ],
}

const _submitHooks = {
  before: [
    validate,
  ],
  after: [
    ui, // display any validation errors
    check,
    withToast(submit, {
      success: {
        color: 'success',
        message: {
          ns: 'common',
          key: 'data.notice.success',
        },
      },
      failure: {
        color: 'error',
        message: {
          ns: 'common',
          key: 'data.notice.failure',
        },
      },
    }),
    updateCache,
    back,
  ],
}

const hooks = {
  [G.ACTIONS]: {
    deleteAccount: _formHooks,
    serialUnknown: _formHooks,
    submit: _submitHooks,
  },
}

export default hooks
